<template>
  <div class="main-cover">
    <div class="main-cover__top">
      <div class="main-cover__top--year">{{ content.year }}</div>
      <div class="main-cover__top--title">{{ content.title }}</div>
      <div class="main-cover__top--dida">{{ content.dida }}</div>
    </div>

    <div class="main-cover__line">
      <div class="main-cover__line--line"></div>
    </div>
    <div class="main-cover__bottom">
      <div class="main-cover__bottom--cta" @click="increment()">
        {{ content.cta }}
        <svgicon
          class="icon"
          name="arrow-right"
          color="var(--ui-white)"
          height="1.625rem"
          width="1.625rem"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "MainCover",
  computed: {
    content() {
      return this.$t("landing");
    },
    ...mapGetters({
      landingIndex: "scroller/landingIndex",
    }),
  },
  methods: {
    ...mapActions({
      increment: "scroller/increment",
    }),
  },
  components: {
    
  }
};
</script>

<style lang="scss" scoped>
.main-cover {
  @include cover-structure;

  padding: toRem(100) calc($background-lines-WIDTH / 2 );
  color: $ui-white;
  width:100%;
  margin-left: toRem($landing-side-WIDTH);
  &__top {
      height: toRem(255); // avoid type to move
    &--year {
      @include title-H3;
    }

    &--title {
      @include title-H0;
    }

    &--dida {
      @include dida-L;
      max-width: toRem(320);
      margin-bottom: toRem(20);
  
    }
  }

  &__line {
    width: calc(100% + toRem($landing-side-WIDTH));
  }

  &__bottom {
    &--cta {
      width: fit-content;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      @include link-M;
      cursor: pointer;
        margin-top: toRem(20);

      .icon {
        transition: transform 0.5s ease;
      }
      &:hover {
        .icon {
          transform: translateX(5px);
        }
      }
    }
  }
}
</style>